var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hc-badge",class:`hc-badge--${_vm.variant}`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }